export const BASE_URL = 'https://stagingapi.indian-drivers.com'
// export const BASE_URL = 'http://192.168.1.23:3000'
// export const BASE_URL = 'https://apiv2.indian-drivers.com'
// export const GOOGLE_MAP_KEY = 'AIzaSyBj0Ztq60YmW_SLX3ow8uO5mcbirrGqH2I'
export const Paytm_MID_LIVE = 'IDCarD52035492281968'
export const kWebsiteLive = 'IDCarDriverswap'
